module.exports = __webpack_public_path__ + "static/media/logo.ca55a56a.png";